import React from 'react';
import { Typography } from '@naf-simba/building-blocks-typography';
import { KeyboardArrowDown } from '@styled-icons/material/KeyboardArrowDown';
import { MobileNavGroupItem } from '../../../../../types/globalSettingsType';
import { MobileMenuCta } from '../MobileMenuCta/MobileMenuCta';
import { MobileMenuIcon } from '../MobileMenuIcon/MobileMenuIcon';
import { MobileMenuLink } from '../MobileMenuLink/MobileMenuLink';
import * as S from './MobileMenuGroup.styles';

interface MobileMenuGroupProps {
  group?: MobileNavGroupItem | null;
  index: number;
  isExpanded: boolean;
  onToggle: (index: number) => void;
  onLinkClick?: () => void;
}

export const MobileMenuGroup = ({ group, index, isExpanded, onToggle, onLinkClick }: MobileMenuGroupProps) => {
  const panelId = `mobile-menu-panel-${index}`;
  const buttonId = `mobile-menu-button-${index}`;
  const hasPanelContent = Boolean(group?.links?.length || group?.cta);
  const handleToggle = React.useCallback(() => {
    onToggle(index);
  }, [index, onToggle]);

  if (!group?.header || !hasPanelContent) return null;

  return (
    <S.Group>
      <S.HeaderButton
        id={buttonId}
        type="button"
        aria-expanded={isExpanded}
        aria-controls={panelId}
        onClick={handleToggle}
      >
        <S.IconWrapper>
          <MobileMenuIcon name={group.icon} />
        </S.IconWrapper>
        <Typography variant="titleL">{group.header}</Typography>
        <S.ChevronWrapper $isExpanded={isExpanded}>
          <KeyboardArrowDown size={24} aria-hidden />
        </S.ChevronWrapper>
      </S.HeaderButton>
      <S.Panel id={panelId} role="region" aria-labelledby={buttonId} $isExpanded={isExpanded} onClick={onLinkClick}>
        <S.Links>
          {group.links?.map((item, itemIndex) => (
            <MobileMenuLink
              key={item?.header ?? itemIndex}
              item={item}
              menuSectionName={group.header}
              mobileMenuGroup={group.header}
            />
          ))}
        </S.Links>
        <MobileMenuCta cta={group.cta} mobileMenuGroup={group.header} />
      </S.Panel>
    </S.Group>
  );
};
